
import styles from "./PartWorkReport.module.scss";
import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import PartWorkItemReport from './PartWorkItemReport/PartWorkItemReport';
import TestChangeForm from "components/Forms/TestForm/TestChangeForm";
import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { Icon } from 'components'
const PartWorkReport = ({title_dat, id, setRender, partWorkTests }) => {
 const { t } = useTranslation('common');
 const componentRef = useRef();

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });
  const [edit_id, setEditId] = useState(null);

  const ChangeRowOn = (id) => {
    setEditId(id);
  }
  
  return (
    <>
    <button className={styles.btn_print} onClick={handlePrint}>{t('common.print')} <Icon name="print" /></button>
    <div ref={componentRef}  className={styles.test_card}>
      <div className={styles.div_print}><h4>{t('tests.report.report_for', { title: title_dat })}</h4><h4>{t('tests.report.report_date', { date: new Date().toLocaleString("ru-RU") })}</h4> </div>
      {partWorkTests.map((item, index) =>
        item.id !== edit_id ? (
          <>
          <PartWorkItemReport
            item={item}
            index={index}
            setRender={setRender}
            MassLength={partWorkTests.length}
            ChangeRowOn={ChangeRowOn}
          />
        
          </>
        ) : (
         <></>
          
        )
      )}


    </div >
    </>
  );
};

export default PartWorkReport;
